import api from '@/api/API';
import { AccountSubscriber, AccountSubscriberFilters } from '@/types';

export default {
  find(id: string): Promise<AccountSubscriber> {
    return api
      .get(`account-subscribers/${id}`)
      .then(response => response.data);
  },
  findAll(filters: AccountSubscriberFilters): Promise<AccountSubscriber[]> {
    return api
      .get('account-subscribers', {
        params: filters,
      }).then(response => response.data);
  },
};
